module.exports = "https://static.energy5.com/_next/static/images/operation-4f65ae797c084903574b0e2846cad2d3.png";